var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-5da7233b-42dc-4039-a179-626a7fbd265c",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.85 79.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.85,76.11c0,2.07-1.67,3.74-3.74,3.74H3.74c-2.07,0-3.74-1.67-3.74-3.74v-17.47c0-2.07,1.67-3.74,3.74-3.74H26.62l7.64,7.64c3.13,3.13,8.19,3.13,11.32,0l7.64-7.64h22.88c2.07,0,3.74,1.67,3.74,3.74v17.47ZM46.17,0c2.07,0,3.74,1.67,3.74,3.74V29.95h13.68c2.78,0,4.16,3.35,2.2,5.32l-23.72,23.74c-1.17,1.17-3.09,1.17-4.26,0L14.05,35.26c-1.97-1.96-.58-5.32,2.2-5.32h13.69V3.74c0-2.07,1.67-3.74,3.74-3.74h12.48Zm11.23,69.25c-1.72,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12,3.12-1.4,3.12-3.12-1.4-3.12-3.12-3.12Zm9.98,0c-1.72,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12,3.12-1.4,3.12-3.12-1.4-3.12-3.12-3.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkDownload);
export default __webpack_public_path__ + "static/media/dark - download.50fb5e7741654b2e51233fad529594eb.svg";
export { ForwardRef as ReactComponent };